/* eslint-disable import/first */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { CustomViewButton } from "./styles";
import { SearchIcon } from "../../Icons";
export function ViewButton(_a) {
    var children = _a.children, themeColor = _a.themeColor, isGridButton = _a.isGridButton, props = __rest(_a, ["children", "themeColor", "isGridButton"]);
    var _b = useState("#F2F2F2"), hoverColor = _b[0], setHoverColor = _b[1];
    return (_jsx(CustomViewButton, __assign({ style: {
            backgroundColor: hoverColor,
            height: isGridButton ? "30px" : "40px",
            width: isGridButton ? "30px" : "40px",
        }, onMouseOver: function () { return setHoverColor(themeColor ? themeColor : "#FB9006"); }, onMouseOut: function () { return setHoverColor("#F2F2F2"); } }, props, { children: _jsx(SearchIcon, { size: "25", color: "#FB9006" }) })));
}
